module.exports = __webpack_public_path__ + "img/dark_meal.877c0f8f.png";